export default {
  Otro: 1,
};
